let CURRENT_GST_RATE = 0;

function gstData(t) {
  CURRENT_GST_RATE = Number(t) || 0;
}

function updateCartCount() {

  setTimeout(() => {

    fetch("/cart.js")
      .then((t) => t.json())
      .then((t) => updateCartBubble(t.item_count));

  }, 1e3);

}

function updateCartNotification(t) {

  if (!t || !t.title) return;

  const n = CURRENT_GST_RATE,
    a = Number(t.presentment_price || t.price / 100),
    e = Math.round(a + (a * n) / 100),
    i = Math.round(t.quantity),

    o = `

    <div class="cart-notification-product__image global-media-settings">

      <img
        src="${t.image || t.featured_image?.url || ""}"
        alt="${t.title}"
        width="70"
        height="70"
        loading="lazy">

    </div>

    <div>

      <h3 class="cart-notification-product__name h4">
        ${t.title}
      </h3>

      <div class="releaf-qty-price">

        <dl>

          <div class="product-option releaf-related-product-mini">

            <p class="cart-item-quantity">
              Qty: ${i}
            </p>

          </div>

          <div class="product-option">

            <p class="cart-item-price">
              Rs. ${e}
            </p>

          </div>

        </dl>

      </div>

    </div>

  `;

  $("#cart-notification-product").empty().append(o);

}

function openCartNotification() {

  const t = $("#cart-notification");

  t.length && (

    t.removeAttr("hidden")
      .attr("aria-hidden", "false")
      .addClass("active"),

    $("body").addClass("overflow-hidden")

  );

}

function updateCartBubble(t) {

  const n = document.querySelector("#cart-icon-bubble");

  if (!n) return;

  const a = n.querySelector(".cart-count-bubble");

  a && a.remove();

  const e = n.querySelector(".visually-hidden");

  if ((e && e.remove(), t <= 0)) return;

  const i = document.createElement("span");

  i.className = "visually-hidden";

  i.textContent = "Cart";

  const o = document.createElement("div");

  o.className = "cart-count-bubble";

  o.innerHTML = `
    <span aria-hidden="true">${t}</span>
    <span class="visually-hidden">${t} items</span>
  `;

  n.appendChild(i);

  n.appendChild(o);

}

document.addEventListener("click", function (t) {

  const n = t.target.closest(".related-add");

  if (!n) return;

  t.preventDefault();

  t.stopImmediatePropagation();

  const variantId = n.getAttribute("data-variant-id"),
        gstRate = n.getAttribute("data-gst-rate");

  if (!variantId) return;

  gstData(gstRate);

  n.disabled = true;

  // =========================
  // GET CURRENT CART
  // =========================

  fetch("/cart.js")

    .then(res => res.json())

    .then(cart => {

      let existingItem = cart.items.find(

        item => Number(item.variant_id) === Number(variantId)

      );

      // =========================
      // PRODUCT EXISTS
      // =========================

      if (existingItem) {

        // UPDATE QUANTITY

        fetch('/cart/update.js', {

          method: 'POST',

          headers: {
            'Content-Type': 'application/json'
          },

          body: JSON.stringify({

            updates: {
              [existingItem.key]: existingItem.quantity + 1
            }

          })

        })

        .then(() => fetch('/cart.js'))

        .then(res => res.json())

        .then(updatedCart => {

          const updatedItem = updatedCart.items.find(

            item => Number(item.variant_id) === Number(variantId)

          );

          if (updatedItem) {

            updateCartNotification(updatedItem);

          }

          updateCartCount();

          openCartNotification();

          $("#cart-notification").addClass("active");

          document.dispatchEvent(new CustomEvent('cart:refresh'));

          $("#cart-notification-product")
            .removeClass("releaf-noti-cart-mini-detailspage");

        })

        .catch(() => {

          console.log("Error updating cart quantity");

        })

        .finally(() => {

          n.disabled = false;

        });

      } else {

        // =========================
        // ADD NEW PRODUCT
        // =========================

        $.ajax({

          url: "/cart/add.js",

          method: "POST",

          dataType: "json",

          data: {

            id: variantId,

            quantity: 1,

            properties: {
              _gst_rate: gstRate
            }

          },

          success: function (data) {

            updateCartNotification(data);

            updateCartCount();

            openCartNotification();

            $("#cart-notification").addClass("active");

            document.dispatchEvent(new CustomEvent('cart:refresh'));

            $("#cart-notification-product")
              .removeClass("releaf-noti-cart-mini-detailspage");

          },

          error: function () {

            console.log("Error adding product to cart");

          },

          complete: function () {

            n.disabled = false;

          }

        });

      }

    });

});

$(document).on(

  "click",

  ".cart-notification__close, .cart-notification__links button.link",

  function () {

    $("#cart-notification")
      .attr("aria-hidden", "true")
      .removeClass("active");

    $("body").removeClass("overflow-hidden");

  }

);